import React, { useEffect, createElement } from 'react';
import { HeroSection } from './HeroSection';
import { ContentSections } from './ContentSections';
import { ProductSection } from './ProductSection';
import { BeforeAfterSection } from './BeforeAfterSection';
import { BonusSection } from './BonusSection';
import { TestimonialsSection } from './TestimonialsSection';
import { PricingSection } from './PricingSection';
import { FAQSection } from './FAQSection';
import { PurchasePopup } from './PurchasePopup';
export function LandingPage() {
  useEffect(() => {
    const pixelId = '1555659168850991';
    try {
      // Set up fbq function before loading the script
      const w = window as any;
      if (!w.fbq) {
        const fbq = function (...args: any[]) {
          if (fbq.callMethod) {
            fbq.callMethod.apply(fbq, args);
          } else {
            fbq.queue.push(args);
          }
        } as any;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [] as any[];
        w.fbq = fbq;
        if (!w._fbq) w._fbq = fbq;
      }
      // Load the FB pixel script safely using head.appendChild
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // Init and track
      w.fbq('init', pixelId);
      w.fbq('track', 'PageView');
    } catch (e) {
      // Silently fail — pixel is non-critical
      console.warn('Meta Pixel failed to initialize:', e);
    }
  }, []);
  return <div className="min-h-screen bg-gray-100 font-sans selection:bg-green-200 selection:text-green-900" data-id="element-190">
      <main className="w-full bg-white shadow-2xl mx-auto" data-id="element-191">
        <HeroSection data-id="element-192" />
        <ContentSections data-id="element-193" />
        <ProductSection data-id="element-194" />
        <BeforeAfterSection data-id="element-195" />
        <BonusSection data-id="element-196" />
        <TestimonialsSection data-id="element-197" />
        <PricingSection data-id="element-198" />
        <FAQSection data-id="element-199" />
      </main>
      <PurchasePopup data-id="element-200" />
    </div>;
}